//---------------------------------------------------
//  Nom du fichier : Recherche.js 
//
//  Description: Component qui gère la recherche de publication
//               ou d'utilisateur
//               
//  Auteur: Alek Del Balso
//---------------------------------------------------
import './Rencontre.css'
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { callAPI } from './callAPI';

function Recherche({setter = null, toChat = false, showResult=true})  {
    const [researchItem, setResearchItem] = useState([])
    const [researchText, setResearchText] = useState([])
    const { t } = useTranslation();
    const navigate = useNavigate();

    const typing = (name) => {

        setResearchText(name)

        if(name == ""){
            setResearchItem([])
            if(setter){setter([])}
            return
        }
        let form = new FormData()
        if(setter){
            form.append("type", "search_post")
        }
        else{
            form.append("type","search_profiles")
            
        }

        form.append("value",name)
        callAPI("read", form)
        .then((data) => {
            setResearchItem(data.result)
            if(setter){
                setter(data.result)
            }
        })
        .catch((error) => {
            console.error("API call failed:", error);
        });
    }

    return (
        <>
            <div className='recherche_container'>
                <input  placeholder={t('research')}
                        className='rencontre_research' 
                        value={researchText} 
                        onChange={e => typing(e.target.value)}
                        onBlur={() => {
                            setTimeout(() => {
                                setResearchItem([])
                            },100)}}/>
                {showResult && 
                    <div className='research_response'>
                        {
                            researchItem.map((item, index) => (
                                   <div key={index} title={item.username} className='response_container' onClick={() => {toChat ? window.location.href = `/chat/${item.id}` : navigate(`/profil/${item.id}`)}}  >
                                        <div className='response_image' style={{backgroundImage: item.file_path !== null ? `url('https://rockstoclimb.com/uploads/profiles/${item.file_path}')` : 'url("/Images/defImage.png")'}}>  </div>
                                        <div className='response'>{item.username}</div>
                                    </div>))
                        }  
                    </div>
                }
            </div>
        </>
    )
}

export default Recherche;